export default "__VITE_ASSET__$NaiTXUV__"